export const REPORT_SECTION_LABELS = {
    cover: "Report overview",
    business_registration: "Business and registration",
    plan_setup: "Food control plan",
    people_training: "People, training and sickness",
    suppliers_allergens: "Suppliers and allergens",
    temperatures: "Temperature logs",
    process_records: "Cooking and process methods",
    cleaning_maintenance: "Cleaning and maintenance",
    problems: "Problems and recalls",
    internal_checks: "Internal checks",
    photos: "Evidence photos",
};
export function summarizeReport(rdm) {
    const result = (values) => ({
        passed: values.filter((value) => value === "pass").length,
        attention: values.filter((value) => value === "warn").length,
        failed: values.filter((value) => value === "fail").length,
    });
    return rdm.sections
        .filter((section) => section.key !== "cover" && section.included)
        .map((section) => {
        let count = 0;
        let values = [];
        switch (section.key) {
            case "business_registration":
                count = 1;
                break;
            case "plan_setup":
                count =
                    section.data.equipment.length +
                        section.data.cleaning_plan.length +
                        section.data.nearby_risks.length +
                        section.data.separation_controls.length +
                        section.data.layout_documents.length;
                break;
            case "people_training":
                count =
                    section.data.staff.reduce((sum, staff) => sum + staff.completions.length, 0) + section.data.sickness_records.length;
                break;
            case "suppliers_allergens":
                count =
                    section.data.suppliers.length +
                        section.data.deliveries_by_month.reduce((sum, month) => sum + month.count, 0) +
                        section.data.menu_items.length +
                        section.data.business_to_business_supplies.length;
                break;
            case "temperatures": {
                const readings = [
                    ...section.data.hot_hold_and_display,
                    ...section.data.assets.flatMap((asset) => asset.weeks.flatMap((week) => week.readings)),
                ];
                count = readings.length;
                values = readings.map((reading) => reading.result);
                break;
            }
            case "process_records": {
                const records = section.data.methods.flatMap((method) => method.records);
                count = records.length;
                values = records.map((record) => record.result);
                break;
            }
            case "cleaning_maintenance":
                count =
                    section.data.cleaning.length +
                        section.data.maintenance.length +
                        section.data.calibrations.length;
                values = [
                    ...section.data.cleaning.map((item) => item.result),
                    ...section.data.calibrations.map((item) => item.result),
                ];
                break;
            case "problems":
                count = section.data.items.length;
                break;
            case "internal_checks":
                count =
                    section.data.audits.length +
                        section.data.verification_outcomes.length;
                values = section.data.audits.map((audit) => audit.result);
                break;
            case "photos":
                count = rdm.photos.items.length;
                break;
        }
        return {
            key: section.key,
            label: REPORT_SECTION_LABELS[section.key],
            count,
            results: result(values),
        };
    });
}
